import React, { useEffect, useState } from "react";
import MainCard from '@/components/MainCard';
import {
  Steps,
  Descriptions,
  Table,
  Empty,
  Flex,
  ConfigProvider,
  Modal,
  Input,
  Timeline,
  Typography as Typography1,
  Tag,
  Card,
  Tooltip,
  Button,
} from "antd";

const { Title } = Typography1;
// Ant Design components are used instead of MUI
import { ClockCircleOutlined } from '@ant-design/icons';
import { Eye, CheckCircle, XCircle, CheckCheck } from 'lucide-react';
// Component alias for MUI compatibility
const IconButton = Button;
import {
  bp_get_batch_approval_details,
  bp_update_approval_status_for_recipe,
} from '@/utils/api';
import { defaultColors } from '@/themes/antd-theme';
import { toast } from "react-toastify";
import ReusableSearchInput from '@/components/ReusableSearch';
import { useSelector } from "react-redux";
import { useTheme } from '@/App';
import Icons from '@/components/third-party/Icons';
import { useTranslation } from 'react-i18next';
const approval_status_json = {
  approve: (
    <CheckCheck size={20} style={{ color: defaultColors.success }} />
  ),
  Pending: (
    <ClockCircleOutlined style={{ color: defaultColors.warning, fontSize: "20px" }} />
  ),
};

const status_tag_json = {
  approve: <Tag color="success">Approved</Tag>,
  Pending: <Tag color="warning">Pending</Tag>,
};

const RecipeViewApproval = ({ searchvalue }) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const textColor = isDark ? '#ffffff' : '#1f2937';

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const selectedModule = useSelector((state) => state.moduleView);
  const [record, set_record] = useState("");
  const [loading, set_loading] = useState(false);
  const [recipe_data, set_recipe_data] = useState([]);
  const get_all_dropDown_Data_on_submit = async () => {
    try {
      set_loading(true);
      await bp_get_batch_approval_details(success_recipe_data);
    } catch (error) {
      set_loading(false);
      console.error("Error fetching data:", error);
    }
  };

  const success_recipe_data = (res) => {
    set_loading(false);
    set_recipe_data(res?.data?.data || []);
  };

  const success = async (res) => {
    if (res.status === "success") {
      toast.success(res.message);
      try {
        await bp_get_batch_approval_details(success_recipe_data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else if (res.status === "failed") {
      toast.warning(res.message);
    }
  };

  useEffect(() => {
    get_all_dropDown_Data_on_submit();
  }, []);

  const [comment, set_comment] = useState("");

  const warning = (record) => {
    Modal.warning({
      title: "Comment",
      cancelText: "Cancel",
      closable: true,
      maskClosable: true,
      content: (
        <Input
          placeholder="Enter Comment"
          onChange={(e) => {
            set_comment(e.target.value);
          }}
        />
      ),

      onOk() {
        bp_update_approval_status_for_recipe(
          {
            comment: comment,
            batch_approval_id: record?.batch_approval_id,
            approval_status: false,
          },
          success
        );
      },
    });
  };

  const columns1 = [
    {
      title: `${selectedModule === "prod" ? "BMR" : "BPR"} Number`,
      dataIndex: "batch_number",
      key: "batch_number",
      align: "center",
      sorter: (a, b) => a.batch_number?.localeCompare(b?.batch_number), // ✅ sorting
      filteredValue: [searchvalue],
      onFilter: (value, record) => {
        return (
          String(record.batch_number)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.recipe_name)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.process_name)
            .toLowerCase()
            .includes(value.toLowerCase())
        );
      },
    },
    {
      title: "Recipe Name",
      dataIndex: "recipe_name",
      key: "recipe_name",
      align: "center",
      sorter: (a, b) => a.recipe_name?.localeCompare(b?.recipe_name), // ✅ sorting
    },
    {
      title: "Process Name",
      dataIndex: "process_name",
      key: "process_name",
      align: "center",
      sorter: (a, b) => a.process_name?.localeCompare(b?.process_name), // ✅ sorting
    },
    {
      title: "View Approvals",
      key: "view_approvals",
      align: "center",
      render: (_, record) => {
        return (
          <Tooltip title="View">
            <Button
              type="text"
              icon={<Eye size={20} style={{ color: defaultColors.primary }} />}
              onClick={() => {
                setIsModalOpen(true);
                set_record(record);
              }}
            />
          </Tooltip>
        );
      },
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   align: "center",
    //   render: (_, record) => {
    //     return (
    //       <Stack direction="row" spacing={2} justifyContent="center">
    //         <Tooltip title="Approve">
    //           <IconButton
    //             onClick={() => {
    //               bp_update_approval_status_for_recipe(
    //                 {
    //                   batch_approval_id: record?.batch_approval_id,
    //                   approval_status: true,
    //                 },
    //                 success
    //               );
    //             }}
    //           >
    //             <CheckCircleIcon style={{ color: "green" }} />
    //           </IconButton>{" "}
    //         </Tooltip>
    //         <Tooltip title="Reject">
    //           <IconButton
    //             onClick={() => {
    //               warning(record);
    //             }}
    //           >
    //             <CancelIcon style={{ color: "red" }} />
    //           </IconButton>
    //         </Tooltip>
    //       </Stack>
    //     );
    //   },
    // },
  ];

  const get_Ingredients = (record) => {
    return (
      <Table
        size="small"
        bordered
        title={() => "Ingredients"}
        dataSource={record?.ingredients}
        columns={[
          {
            title: "Ingredient Name",
            dataIndex: "ingredient_name",
            key: "ingredient_name",
          },
          {
            title: "Condition",
            dataIndex: "conditinal_para",
            key: "conditinal_para",
          },
          {
            title: "Quantity",
            key: "quantity",
            render: (_, record) =>
              `${record?.ingredient_qty}${" "}${record?.unit}`,
          },
        ]}
        pagination={false}
      />
    );
  };

  const get_sampling = (record) => {
    return (
      <Table
        size="small"
        bordered
        title={() => "Sampling"}
        dataSource={record?.sampling}
        columns={[
          {
            title: "Material Inventory Name",
            dataIndex: "material_inventory_name",
            key: "material_inventory_name",
          },
          {
            title: "Testing Type Name",
            dataIndex: "testing_type_name",
            key: "testing_type_name",
          },
          {
            title: "Sample Number",
            dataIndex: "sample_number",
            key: "sample_number",
          },
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            render: (_, record) =>
              `${record?.quantity}${" "}${record?.material_inventory_unit}`,
          },
          {
            title: "Sample Quantity",
            dataIndex: "sample_quantity",
            key: "sample_quantity",
            render: (_, record) =>
              `${record?.sample_quantity}${" "}${
                record?.material_inventory_unit
              }`,
          },
        ]}
        pagination={false}
      />
    );
  };

  const get_Product = (record) => {
    return (
      <p style={{ margin: 0 }}>
        <Table
          size="small"
          bordered
          title={() => "Product"}
          dataSource={record?.products}
          columns={[
            {
              title: "Product Name",
              dataIndex: "product_name",
              key: "product_name",
            },
            {
              title: "value",
              key: "value",
              render: (_, record) => {
                return (
                  record?.value?.length > 0 && (
                    <Flex gap="20px" vertical={true} justify="flex-start">
                      <Table
                        size="small"
                        bordered
                        dataSource={record?.value}
                        columns={[
                          {
                            title: "Container Id",
                            dataIndex: "container_id",
                            key: "created_on",
                          },
                          {
                            title: "Tare Wt",
                            dataIndex: "tare_weight",
                            key: "value",
                          },
                          {
                            title: "Gross Wt",
                            dataIndex: "gross_weight",
                            key: "value",
                          },
                          {
                            title: "Net Wt",
                            dataIndex: "net_weight",
                            key: "value",
                          },
                        ]}
                        pagination={false}
                      />
                    </Flex>
                  )
                );
              },
            },
          ]}
          pagination={false}
        />
      </p>
    );
  };

  const get_Parmeters = (record) => {
    return (
      <Table
        size="small"
        bordered
        title={() => "Parameters"}
        dataSource={record?.paramaters}
        columns={[
          {
            title: "Parameter Name",
            dataIndex: "parameter_name",
            key: "parameter_name",
          },
          {
            title: "value",
            key: "value",
            render: (_, record) => {
              return (
                record?.value?.length > 0 && (
                  <Table
                    size="small"
                    bordered
                    dataSource={record?.value}
                    columns={[
                      {
                        title: "Created On",
                        dataIndex: "created_on",
                        key: "created_on",
                        render: (created_on) => created_on?.slice(0, 19),
                      },
                      {
                        title: "Value",
                        dataIndex: "value",
                        key: "value",
                      },
                    ].filter(Boolean)}
                    pagination={false}
                  />
                )
              );
            },
          },
        ]}
        pagination={false}
      />
    );
  };

  const addKeysInFilterDataForCollapse = (filterData) => {
    const updatedFilterList = filterData?.map((item, index) => {
      return {
        ...item,
        key: index.toString(), // Update the key to the index converted to a string
      };
    });
    return updatedFilterList;
  };

  return (
    <div className="p-0 min-h-screen" style={{ backgroundColor: isDark ? defaultColors.palette.gray[900] : '#f9fafb' }}>
      <Card
        className="shadow-sm"
        bordered={false}
        style={{ backgroundColor: isDark ? defaultColors.palette.gray[800] : '#ffffff' }}
        title={
          <div className="flex items-center gap-2">
            <Icons.CheckCircle className="text-blue-600" size={24} />
            <Title
              level={4}
              style={{
                color: textColor,
                margin: 0,
                padding: 0,
              }}
            >
              {t('Recipe View Approval')}
            </Title>
          </div>
        }
      >
      <Table
        columns={columns1}
        bordered
        dataSource={addKeysInFilterDataForCollapse(recipe_data)}
        loading={loading}
        // expandable={{ expandedRowRender: expandableRowRender, indentSize: 0 }}
      />
      <Modal
        title="Approvals"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
      >
        <Timeline
          mode="alternate"
          items={record?.status_list?.map((item) => {
            return {
              dot: approval_status_json[item?.approval_status],
              children: (
                <>
                  <Typography1>{item?.role_name}</Typography1>
                  {status_tag_json[item?.approval_status]}
                </>
              ),
            };
          })}
        />
      </Modal>
      </Card>
    </div>
  );
};

export default RecipeViewApproval;
